// Б.1.d: Бишор trigger.
// «[Когда союзный юнит получает Модификацию]: Герой получает +1/0/0 до конца матча».
// Срабатывает только если юнит — союзник Героя-Бишора (ownerIdx совпадает).
// Не срабатывает на Моды на ВРАЖЕСКОГО юнита.

export const HERO_ID = 'syn_bishor';

export function bishorOnAllyModified(state, ownerIdx, targetCard) {
  if (ownerIdx == null) return;
  const player = state.players[ownerIdx];
  if (!player || player.hero?.id !== HERO_ID) return;
  if (player.hero.hp <= 0) return;
  if (!targetCard || targetCard.type !== 'unit') return;
  const before = player.hero.current.atk;
  player.hero.current.atk += 1;
  const after = player.hero.current.atk;
  state.log.add(`✨ Бишор [${player.name}]: +1 atk от Мода (atk ${before}→${after})`);
}
